import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IParametroModel } from 'src/app/models/interfaces/parametros/IParametroModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-parametros-configuracion-editar',
  templateUrl: './parametros-configuracion-editar.component.html',
  styleUrls: ['./parametros-configuracion-editar.component.scss']
})
export class ParametrosConfiguracionEditarComponent implements OnInit {
  id: number = 0;
  idMaestro: number = 0;
  model: IParametroModel = new ParametroModel();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,) { }

    ngOnInit(): void {
      this.route.params.subscribe((params) => {
        this.id = params['id'];
        this.idMaestro = params['idMaestro'];
      });
  
  
      this.serviceParametros.getDetail(this.idMaestro,this.id).subscribe((data) => {
        this.model = data;
      });
    }

    onSubmit(form: NgForm) {
      if (!form.invalid) {  
        this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
        this.confirmDialogService.confirmed().subscribe((confirmed) => {
          if (confirmed) {
            this.serviceParametros.updateDetail(this.model).subscribe((data) => {
              this.router.navigate(['/configuracion', 'parametros-configuracion']);  
            });
          }
        });
      }
    }

}
